// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Comments-cls1__bac79ca426e0eec12225{/*!*/}.Comments-cls2___69b7bebbb138857c603{height:20px !important;width:20px !important;padding:0 !important}.Comments-cls2___69b7bebbb138857c603:focus{outline:none !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Comments-cls1__bac79ca426e0eec12225",
	"cls2": "Comments-cls2___69b7bebbb138857c603 Comments-cls1__bac79ca426e0eec12225"
};
export default ___CSS_LOADER_EXPORT___;
